import React from 'react';
import { styled } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import InfoIcon from '@mui/icons-material/Info';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';



const PREFIX = 'BuildingSelectItem';

const classes = {
    formControl: `${PREFIX}-formControl`,
    selectEmpty: `${PREFIX}-selectEmpty`,
    filterTextPrimary: `${PREFIX}-filterTextPrimary`,
    filterTextSecondary: `${PREFIX}-filterTextSecondary`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.formControl}`]: {
        minWidth: '100%',
    },

    [`& .${classes.selectEmpty}`]: {
        marginTop: theme.spacing(2),
    },

    [`& .${classes.filterTextPrimary}`]: {
        fontSize: theme.typography.pxToRem(14), /*fontsize of the selected element and the inside menu*/
    },

    [`& .${classes.filterTextSecondary}`]: {
        fontSize: theme.typography.pxToRem(13), /*aparantly not used*/
    },
    selectDiv:{
        display: 'flex',
        justifyContent: 'start'
    }
}));

function BuildingSelect(props) {

    const {
        handleChangeBuilding,
        building,
        data,
        required,
    } = props;
    //const theme = useTheme();

    const menuItemArray = []
    for (var i = 0; i < data.length; i++) {
        menuItemArray.push(
            <MenuItem key={data[i].id} value={data[i].name} >
                <Typography className={classes.filterTextPrimary} sx={data[i].serverDisabled? {color: "#c0c0c0"}: null} >
                {data[i].name}
                </Typography>
                {data[i].serverDisabled ? 
                    <Tooltip title={data[i].errroMessage}>
                    <IconButton disableFocusRipple="true" disableRipple="true" size="small" >
                        <InfoIcon/>
                    </IconButton>
                    </Tooltip>
                : null
                }
            </MenuItem>
        )
    }

    var labelText = "Selecciona un edificio";
    if (required) {
        labelText = <Box color="error.main"> Seleccione un edificio *</Box>;

    }

    return (
        <Root>
            <FormControl variant="standard" className={classes.formControl}>
                <Select value={building} onChange={handleChangeBuilding} displayEmpty className={classes.selectEmpty}>
                    <MenuItem value="" disabled>
                        <Typography component ={'div'} className={classes.filterTextPrimary}>
                            {labelText}
                        </Typography>
                    </MenuItem>
                    {menuItemArray}
                </Select>
            </FormControl>
        </Root>
    )
}

function BuildingSelectItem(props) {
    return (
        <div>
            <ListItem>
                <ListItemText primary={
                    <BuildingSelect
                        {...props}
                    />
                } />
            </ListItem>
            <Divider />
        </div>
    )
}

export default BuildingSelectItem;